import React, { useEffect } from 'react';
import { Drawer, Select, Form, InputNumber, Button, message } from 'antd';
import { requiredRule } from 'utils/forms/validationRules';
import { thousandFormatter } from 'utils/forms/formatter';
import { PaymentsService } from 'services/PaymentsService';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { taxesSet, updateStatuses } from 'utils/handbooks/paymentsHandbook';

function ClientPaymentsForm({ isActive, onClose, initialValues, onSuccess }) {
  const [form] = Form.useForm();

  const isTaxPayment = initialValues
    ? taxesSet.has(initialValues?.type)
    : false;

  useEffect(() => {
    if (initialValues) {
      const { status, amount } = initialValues;

      form.setFieldsValue({
        status,
        amount,
      });
    }
  }, [initialValues]);

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      id: initialValues.id,
    };

    try {
      const res = await PaymentsService.editClientPayment(payload);

      if (res) {
        message.success('Платеж успешно отредактирован');
        form.resetFields();
        onSuccess();
      }
    } catch (err) {
      message.error('Не удалось отредактировать платёж');
    }
  };

  return (
    <Drawer
      title="Редактирование платежа"
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="status" label="Статус" rules={[requiredRule]}>
          <Select placeholder="Выбрать статус">
            {updateStatuses.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="amount" label="Сумма" rules={[requiredRule]}>
          <InputNumber
            addonAfter="KZT"
            disabled={isTaxPayment}
            controls={false}
            placeholder="Цена"
            style={{ width: '100%' }}
            formatter={thousandFormatter}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { ClientPaymentsForm };
